export default __webpack_public_path__ + "static/media/download_app.f94b387d.png";